import Home from './components/pages/Home.vue'
import ProdRMConfig from './routermappings/products_rm_config.js'
import FormiaRMConfig from './routermappings/formia_rm_config.js'
import AMSCtrlRMConfig from './routermappings/amscontrols_rm_config.js'
export function configRouter(router) {
    router.map({
        '/:langID': {
            component: Home
        },
		'/:langID/search': {
			name: 'search',
			component(resolve) {
				require(['./Search.vue'], resolve)
			}
		},

		'/:langID/contact': {
			component (resolve) {
				require(['./components/pages/contact/Contact.vue'], resolve)
			}
		},

		'/:langID/about': {
			component (resolve) {
				require(['./components/pages/About.vue'], resolve)
			},
			subRoutes: {
				'/ALLMAC': {
					component(resolve) {
						require(['./components/pages/abouts/aboutALLMAC.vue'], resolve)
					}
				},
				'/ALLMAC-EUROPE-FORMIA': {
					component(resolve) {
						require(['./components/pages/abouts/aboutALLMAC_EF.vue'], resolve)
					}
				}
			}
		},

		'/:langID/oem': {
			component (resolve) {
				require(['./components/pages/oem/Oem.vue'], resolve)
			}
		},

		'/:langID/amscontrols': AMSCtrlRMConfig,
		'/:langID/products': ProdRMConfig,
		'/:langID/formia-solutions': FormiaRMConfig
	})
	router.alias({
		'/': '/en',
		'/search/': '/en/search',
		'/about': '/en/about',
		'/oem': '/en/oem',
		'/contact': '/en/contact',
//		'/amscontrols': '/en/amscontrols',
		'/amscontrols/:control': '/en/amscontrols/:control',
		'/products/:product': '/en/products/:product',
		'/formia-solutions': '/formia-solutions/te23_1100',
		'/formia-solutions/:product': '/en/formia-solutions/:product'
		//'/products/pbsm/:pbsmProduct': '/en/products/pbsm/:pbsmProduct'
	})
}


// WEBPACK FOOTER //
// ./src/config_router.js